import { Button, Container, Flex, Paper, Text } from "@mantine/core";
import { TextInput, Select } from "react-hook-form-mantine";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

import { usePatchTag } from "../../../api/tag";
import subtypeOptions from "../utils/subtypeOptions";
import LocalizedInput from "../../common/LocalizedInput";
import { web_tagEditSchema, FEATURE_FLAGS } from "@congrs/schemas";
import resolver from "@congrs/resolver";
import { mergeI18nWithDefaults } from "../../../utils/i18nUtils";
import { useIsFeatureEnabled } from "../../../api/featureFlags";

function Form({ data, enableActions, event }) {
  const { id, type, subtype } = data;
  const interestTagsEnabled = useIsFeatureEnabled(
    event?.id,
    FEATURE_FLAGS.ATTENDEE_INTERESTS_TAGS
  );

  const mainLanguage = event?.language || "en";
  const otherLanguages = event?.secondaryLanguages || [];

  const defaultValues = {
    titleI18n: mergeI18nWithDefaults(
      data?.titleI18n,
      mainLanguage,
      otherLanguages
    ),
    type: type || "",
    subtype: subtype || "",
  };

  const { mutate, isPending: isLoading, isError, error } = usePatchTag(id);

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { dirtyFields, isDirty },
  } = useForm({
    defaultValues,
    resolver: resolver(web_tagEditSchema),
  });
  const newType = watch("type");

  useEffect(() => {
    if (dirtyFields.type) {
      setValue("subtype", null);
    }
  }, [dirtyFields, setValue]);

  const onSubmit = (data) => {
    mutate(data, {
      onSuccess: () => {
        reset(data);
      },
    });
  };

  return (
    <Container size={500}>
      <Paper withBorder shadow="md" p={16} mt={16} radius="md">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Select
            label="Type"
            placeholder="Type"
            defaultValue={type}
            name="type"
            withAsterisk
            control={control}
            clearable
            data={[
              { label: "People", value: "people" },
              { label: "Session", value: "session" },
            ]}
            mt="md"
          />
          {newType && (
            <Select
              label="Subtype"
              placeholder="Select type to see subtype options"
              defaultValue={subtype}
              name="subtype"
              withAsterisk
              control={control}
              data={subtypeOptions(newType, { interestTagsEnabled })}
              mt="md"
              clearable
            />
          )}
          <LocalizedInput
            control={control}
            fields={[
              {
                nameBase: "titleI18n",
                label: "Title",
                component: TextInput,
                props: {
                  mt: "sm",
                  placeholder: "Localized title",
                  withAsterisk: true,
                },
              },
            ]}
            mainLanguage={mainLanguage}
            otherLanguages={otherLanguages}
          />

          {isError && (
            <Text c="red" size="sm" mt="md">
              {error.message.includes("Duplicate")
                ? "A tag with this title already exists. Please choose a different title."
                : "An error occurred: " + error.message}
            </Text>
          )}

          <Flex justify="space-between" mt="md">
            <Button
              type="submit"
              loading={isLoading}
              disabled={!enableActions || !isDirty}
            >
              Edit tag
            </Button>
          </Flex>
        </form>
      </Paper>
    </Container>
  );
}

export default Form;
